const CompanyType = Object.freeze({
  CUSTOMER: 'CUSTOMER',
  SALES_TRIAL: 'SALES_TRIAL',
  PARTNER: 'PARTNER',
  INTERNAL: 'INTERNAL',
  OTHER: 'OTHER'
})
export default CompanyType
// RESERVE BELOW
